var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionTransferred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8663 19.9632C20.3133 19.9632 19.8663 19.5152 19.8663 18.9632C19.8663 18.2172 19.5993 16.4282 17.1353 15.9232C16.5943 15.8122 16.2453 15.2842 16.3563 14.7432C16.4673 14.2022 16.9893 13.8522 17.5373 13.9642C20.7283 14.6182 21.8663 16.9752 21.8663 18.9632C21.8663 19.5152 21.4193 19.9632 20.8663 19.9632Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8662 12.5239C16.4612 12.5239 16.0792 12.2749 15.9292 11.8729C15.7362 11.3559 15.9992 10.7789 16.5162 10.5869C17.3242 10.2859 17.8492 9.52994 17.8562 8.66294C17.8562 7.69394 17.1652 6.84294 16.2132 6.64594C15.6722 6.53394 15.3242 6.00394 15.4362 5.46294C15.5492 4.92194 16.0782 4.57294 16.6192 4.68794C18.4952 5.07694 19.8562 6.75194 19.8562 8.66994C19.8442 10.3559 18.7822 11.8759 17.2162 12.4609C17.1002 12.5029 16.9822 12.5239 16.8662 12.5239Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64333 14.5156C4.66433 14.5156 2.43433 17.2696 2.43433 19.9996C2.43433 20.1986 2.51333 20.3896 2.65433 20.5306C2.79433 20.6706 2.98533 20.7496 3.18433 20.7496L16.1023 20.7316C16.5163 20.7306 16.8513 20.3946 16.8513 19.9816C16.8513 17.2606 14.6223 14.5156 9.64333 14.5156Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64331 13.001C12.3313 13.001 14.5183 10.813 14.5183 8.125C14.5183 5.437 12.3313 3.25 9.64331 3.25C6.95531 3.25 4.76831 5.437 4.76831 8.125C4.76831 10.813 6.95531 13.001 9.64331 13.001Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionTransferred);
export default __webpack_public_path__ + "static/media/TRANSACTION_TRANSFERRED.b2b61173701c7813bfaac01d0536781d.svg";
export { ForwardRef as ReactComponent };